<template>
  <v-app>
    <v-app-bar app dense elevation="1" dark>
      <div class="d-flex align-center rocker">
        <!-- <v-img alt="Vuetify Logo" class="shrink mr-2" contain :src="require('@/assets/car_icon.png')"
          transition="scale-transition" width="40" /> -->
        NB-Nova
      </div>

      <v-spacer></v-spacer>

      <v-app-bar-nav-icon class="d-sm-none" @click.stop="drawer = !drawer"></v-app-bar-nav-icon>

      <template v-slot:extension>
        <v-tabs align-with-title class="d-none d-sm-flex">
          <v-tab v-for="link in links" :key="link.href" :to="link.href">
            <v-icon>{{ link.icon }}</v-icon>&nbsp;{{ link.text }}
          </v-tab>
        </v-tabs>
      </template>
    </v-app-bar>

    <v-navigation-drawer v-model="drawer" absolute temporary>
      <v-list nav>
        <v-list-item-group v-model="group">
          <v-list-item v-for="link in links" :key="link.text" :to="link.href">
            <v-icon>{{ link.icon }}</v-icon>
            <span class="ml-1">{{ link.text }}</span>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>

    <v-main>
      <!-- ヘッダー画像 -->
      <v-container>
        <v-parallax :src="require('@/assets/IMG_9435.jpg')" height="350">
          <v-layout column align-center justify-center class="white--text">
            <h1 class="text-h2 rocker text-sm-h1" style="text-shadow: 3px 2px #000000">
              NB-Nova
            </h1>
            <h3 class="text-h5 murphy" style="text-shadow: 2px 2px #000000">
              Unleash your desire without limitations
            </h3>
          </v-layout>
        </v-parallax>
      </v-container>

      <router-view />
    </v-main>

    <v-footer padless>
      <v-container>
        <v-row>
          <v-col cols="12" sm="5">
            <v-row>
              <v-col col="12">
                <div class="d-flex align-center mr-5">
                  有限会社 NAMBA<br>
                  神奈川県公安委員会許可&nbsp;第452530012413号
                </div>
              </v-col>
            </v-row>
            <v-row>
              <v-col col="12">
                <!-- sitemaps -->
                <v-list nav>
                  <v-list-item-group>
                    <v-list-item v-for="link in links" :key="link.href" :to="link.href">
                      <v-icon>{{ link.icon }}</v-icon>&nbsp;
                      <span class="ml-1">{{ link.text }}</span>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-col>
            </v-row>
          </v-col>
          <v-col col2="12" sm="7">
            <!-- <v-row>
              <v-col col="12"><a href="tel:000-000-0000">000-000-0000</a><br />
                〒213-0032<br />
                神奈川県川崎市高津区久地
              </v-col>
            </v-row>
            <v-row>
              <v-col col="12"> <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d12974.843447237125!2d139.59676208045943!3d35.61019822847692!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6018f6a6608a3359%3A0x8913a7aa33fbf814!2z44CSMjEzLTAwMzIg56We5aWI5bed55yM5bed5bSO5biC6auY5rSl5Yy65LmF5Zyw!5e0!3m2!1sja!2sjp!4v1664407938091!5m2!1sja!2sjp"
                  width="100%" height="200" style="border:0;" allowfullscreen="" loading="lazy"
                  referrerpolicy="no-referrer-when-downgrade"></iframe>
              </v-col>
            </v-row> -->
          </v-col>
        </v-row>
        <v-row>
          <v-col class="text-center murphy" cols="12">
            <p>{{ new Date().getFullYear() }} — &copy; NAMBA Co., Ltd. ALLRIGHTS RESERVED.</p>
          </v-col>
        </v-row>
      </v-container>
    </v-footer>
  </v-app>
</template>

<script>
export default {
  name: 'App',
  data: () => ({
    drawer: false,
    group: null,
    links: [
      { text: 'ホーム', href: '/', icon: 'mdi-home' },
      { text: '在庫一覧', href: '/stocks', icon: 'mdi-car-side' },
      { text: 'Sennheiser', href: '/sennheiserPromo', icon: 'mdi-headset' },
      { text: 'Blog', href: '/blog', icon: 'mdi-post' },
      //{ text: 'お問い合わせ', href: '/inquiry', icon: 'mdi-email-fast-outline' },
      //{ text: 'プライバシーポリシー', href: '/privacyPolicy', icon: '' },
    ],
  }),
  mounted() {
    // fetch('/api/nb_nova_api').then(res => {
    //   console.log(res.ok);
    //   console.log(res.url);
    //   return res.json();
    // }).then(data => {
    //   console.log(data);
    // });
  }
};
</script>
